<table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="tab-content"
    multiTemplateDataRows
>
    <!-- provider Column -->
    <ng-container matColumnDef="provider">
        <tr>
            <th
                class="labelTextHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.details.test.testDetail.provider.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelButton" mat-cell *matCellDef="let element">
                {{ element.provider }}
            </td>
        </tr>
    </ng-container>
    <!-- amount Column -->
    <ng-container matColumnDef="amount">
        <tr>
            <th
                class="labelTextHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.details.test.testDetail.amount.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelButton" mat-cell *matCellDef="let element">
                {{ element.amount }}
            </td>
        </tr>
    </ng-container>

    <!-- Totalcount Column -->
    <ng-container matColumnDef="totalCount">
        <tr>
            <th
                class="labelNumberHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.details.test.testDetail.totalCount.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowNumber" mat-cell *matCellDef="let element">
                {{ element.totalCount }}
            </td>
        </tr>
    </ng-container>

    <!-- Matchingcount Column -->
    <ng-container matColumnDef="matchingCount">
        <tr>
            <th
                class="labelNumberHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.details.test.testDetail.matchingCount.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowNumber" mat-cell *matCellDef="let element">
                {{ element.matchingCount }}
            </td>
        </tr>
    </ng-container>

    <!-- noMatchingCount Column -->
    <ng-container matColumnDef="noMatchingCount">
        <tr>
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="labelTextHeader"
            >
                {{
                    "dashboardBizzDev.details.test.testDetail.noMatchingCount.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowText" mat-cell *matCellDef="let element">
                {{ element.noMatchingCount }}
            </td>
        </tr>
    </ng-container>

    <!-- total duration -->
    <ng-container matColumnDef="durationTotal">
        <tr>
            <th
                class="labelTextHeader"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
            >
                {{
                    "dashboardBizzDev.details.test.testDetail.totalDuration.fullLabel"
                        | translate
                }}
            </th>
        </tr>
        <tr>
            <td class="labelRowText" mat-cell *matCellDef="let element">
                {{ element.durationTotal | date: "mm:ss" }}
            </td>
        </tr>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
</table>
